<template>
    <v-form @submit.prevent="updateContact" ref="form">
        <v-card class="form-container">
            <v-toolbar flat height="45px">
                <span class="font-weight-bold">{{ mode }} Billing Contact</span>
                <v-spacer></v-spacer>
                <v-btn icon @click.native="closeDialog()" >
                    <v-icon>close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-alert v-if="error" :value="true" color="error" icon="error" outline>
                {{ errorMessage }}
            </v-alert> 
            <v-card-text>
                <v-layout row wrap>
                    <v-flex xs12 sm12 class="form-item">
                        <v-autocomplete
                            v-model="userId"
                            :disabled="disabled"
                            :items="employees"
                            :loading="loading_employees"
                            :rules="[rules.required]"
                            chips
                            color="primary lighten-2"
                            label="Select employee"
                            item-text="name"
                            item-value="userId"
                            >
                            <template v-slot:selection="data">
                                <v-chip :selected="data.selected" class="chip--select-multi">
                                    <v-avatar>
                                        <v-img ref="avatar" :src="data.item.avatar"></v-img>
                                    </v-avatar>
                                    {{ data.item.name }}
                                </v-chip>
                            </template>
                            <template v-slot:item="data">
                                <template v-if="typeof data.item !== 'object'">
                                    <v-list-tile-content v-text="data.item"></v-list-tile-content>
                                </template>
                                <template v-else>
                                    <v-list-tile-avatar>
                                        <img :src="data.item.avatar">
                                    </v-list-tile-avatar>
                                    <v-list-tile-content>
                                        <v-list-tile-title v-html="data.item.name"></v-list-tile-title>
                                        <v-list-tile-sub-title v-html="data.item.group"></v-list-tile-sub-title>
                                    </v-list-tile-content>
                                </template>
                            </template>
                        </v-autocomplete>
                    </v-flex>
                </v-layout>
                <v-layout row wrap>
                    <v-flex xs12 sm12 class="form-item">
                        <v-switch
                            v-model="primary"
                            label="Primary contact"
                            color="primary"
                            hide-details
                            style="margin:0px 0px 10px 5px;"
                        ></v-switch>
                        <span class="caption">Only one primary contact is required. This contact will appear on statement of account and invoices.</span>
                    </v-flex>
                </v-layout>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions style="margin-right:20px;">
                <v-spacer></v-spacer>
                <v-btn v-if="contactsCount>1" color="red" :loading="loading" @click="dialogOkCancel=true" dark>Remove</v-btn>
                <v-btn color="primary" type="submit" :loading="loading" :disabled="disabled" dark>Save</v-btn>
            </v-card-actions>
        </v-card>

        <v-dialog v-model="dialogOkCancel" persistent width="600">
            <ok-cancel :msg="dialogOkCancelMsg" :dialogOkCancel.sync="dialogOkCancel" @ok="onOk"></ok-cancel>
        </v-dialog>
    </v-form>
</template>
<script>

import rules from '@/helpers/rules'
import employeeApi from '@/api/employees'
import billingApi from '@/api/billing'
import awsS3Helper from '@/helpers/aws-s3'

export default {
    name: 'dialog',
    components: {
        'ok-cancel': ()=> import("@/components/BasicPopups/OkCancel"),
    },
    data () {
        return {
            error: false,
            errorMessage: '',
            loading: false,
            loading_delete: false,
            loading_employees: false,
            disabled: false,
            dialogOkCancel: false,
            dialogOkCancelMsg: 'This action will remove the selected user from Billing Contacts.<br>Do you want to proceed?',
            error: false,
            contactsCount: 0,
            userId: null,
            primary: 0,
            mode: '',
            employees: [],
        }
    },
    methods: {
        async onOk() {
            try {
                this.loading_delete = true
                this.disabled = true

                const data = {
                    userId: this.userId
                }
                const response = await billingApi.deleteContact(data)
                if (response && response.status == 200) {
                    this.$emit('send', null)
                    this.closeDialog()
                }
                this.loading_delete = false
                this.disabled = false
            }catch(error) {
                console.log(error)

                this.errorMessage = error
                this.error = true
            }
        },
        async updateContact() {
            if (this.$refs.form.validate()) {
                try {
                    this.loading = true
                    this.disabled = true

                    const data = {
                        userId: this.userId,
                        primary: this.primary
                    }
                    let response
                    if (this.mode == 'Add')
                        response = await billingApi.addContact(data)
                    else 
                        response = await billingApi.updateContact(data)

                    if (response && response.status == 200) {
                        this.$emit('send', null)
                        this.closeDialog()
                    }
                    this.loading = false
                    this.disabled = false
                }catch(error) {
                    console.log(error)

                    this.errorMessage = error
                    this.error = true
                }
            }
        },
        async setAdd() {
            this.mode = 'Add'
            if (!this.employees.length) await this.getEmployees()
            this.clearForm()
        },
        async setEdit(data, contactsCount) {
            this.mode = 'Edit'
            this.contactsCount = contactsCount
            this.primary = data.primary
            if (!this.employees.length) await this.getEmployees()
            this.userId = data.user.userId
        },
        async getEmployees() {
            try {
                this.loading_employees = true
                this.employees = []
                const response = await employeeApi.getAll()
                if (response && response.status == 200) {
                    const members = response.data.employees
                    members.forEach(item => {
                        this.employees.push({
                            userId: item.userId,
                            name: item.firstName + " " + item.lastName,
                            avatar: awsS3Helper.getAvatarUrl(item.userId),
                            group: item.team
                        })
                    })    
                }
                this.loading_employees = false
            }catch(error) {
                this.errorMessage = error
                this.error = true
            }
        },
        clearForm() {
            this.$refs.form.reset()
            this.loading = false
            this.error = false
            this.errorMessage = ''
        },
        closeDialog() {
           this.$emit('update:dialogAddEditContact', false)
        },
    },
    created() {
        this.rules = rules
    },
    computed: {},
}
</script>
<style scoped>
.form-container {
    border-radius:4px;
}
.form-item {
    padding: 0px 20px 0px 20px;
}
</style>